import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import StudentDashboard from "@/pages/StudentDashboard";
import TeacherDashboard from "@/pages/TeacherDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import LabSelector from "@/pages/LabSelector";
import ExperimentWorkspace from "@/pages/ExperimentWorkspace";
import LabReport from "@/pages/LabReport";
import Paywall from "@/pages/Paywall";

// Handles OAuth callback via URL fragment BEFORE other routes render.
const AppRouter = () => {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
      <Route path="/teacher" element={<ProtectedRoute teacherOnly><TeacherDashboard /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
      <Route path="/paywall" element={<ProtectedRoute><Paywall /></ProtectedRoute>} />
      <Route path="/labs" element={<ProtectedRoute><LabSelector /></ProtectedRoute>} />
      <Route path="/labs/:subject" element={<ProtectedRoute><LabSelector /></ProtectedRoute>} />
      <Route path="/experiment/:experimentId" element={<ProtectedRoute><ExperimentWorkspace /></ProtectedRoute>} />
      <Route path="/report/:reportId" element={<ProtectedRoute><LabReport /></ProtectedRoute>} />
    </Routes>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
